//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region Angular Imports

import { StateService } from '@uirouter/angularjs'
import * as angular from 'angular'

//#endregion

import { Api } from './../api/api.module'
import { LoggerService } from './../common/common.module'
import { LoginModel, PasswordResetModel, PasswordResetEmailModel, SessionModel, UserModel } from '../api/api.models'

import { i18n } from '../common/i18n/common.i18n'

import { Enums } from '../../models/common'
import { SESSION } from '../../models/custom'

import { Permissions } from '../../helpers/permissions'
import { Md5 } from '../../helpers/md5-helper'
import { CommonHelper, ConfigHelper, EventsNames, IUserSession, ToastHelper, LocalizationHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { IMRBaseControlDirectiveController } from '../common/base'
import dxValidator, { dxValidatorOptions, dxValidatorResult } from 'devextreme/ui/validator'
import { dxButtonOptions } from 'devextreme/ui/button'
import { dxTextBoxOptions } from 'devextreme/ui/text_box'
import { dxTextEditorButton } from 'devextreme/ui/text_box/ui.text_editor.base'
import { PasswordPolicyRules } from '../../models/custom/password-policy-rulles'
import { RequiredRule } from 'devextreme/ui/validation_engine'

var moment = require('moment-timezone')

export interface LoginScope extends ng.IScope {
	authenticationMode: Enums.AuthenticationMode
	date: Date
	showError: string
	showInfo: string
	loginModel: LoginModel
	logIn(): ng.IPromise<void>
	loginForm: ng.IFormController
	setLocale(locale: string)
	passwordReset()
	sendEmail()
	isReset: boolean
	canReset: boolean
	keyPressed(keyEvent: any)
	password: string
	password2: string
	languages: any
	showReset()
	hideReset()
	owner: string
	windows10CompatibileHidden: boolean
	loginScreenTheme: string
	loginText: string
	forgotPaswordText: string
	passwordValidationRules: dxValidatorOptions
	confirmPasswordValidationRules: dxValidatorOptions
	newPasswordInputOptions: dxTextBoxOptions
	confirmNewPasswordInputOptions: dxTextBoxOptions
}

export class LoginController extends IMRBaseControlDirectiveController {
	previousLoginModelMd5: string
	loginFailed: boolean = false

	private newPasswordValidator: dxValidator
	private newPasswordConfirmValidator: dxValidator

	constructor($scope: LoginScope, $state: StateService, $location: ng.ILocationService, $q: ng.IQService, api: Api, logger: LoggerService, private userSession: IUserSession) {
		super()

		$scope.loginScreenTheme = ConfigHelper.getSectionValue(Enums.SimaxConfigSection.LoginScreenTheme)
		$('.login').css('background-image', 'url(images/' + $scope.loginScreenTheme + '/login-bg.jpg')

		$scope.loginText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Login)
		$scope.forgotPaswordText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ForgotPassword)

		$scope['i18n'] = i18n
		$scope.isReset = false
		$scope.loginModel = new LoginModel()

		$scope.showReset = () => {
			$scope.isReset = true
		}

		$scope.hideReset = () => {
			$scope.isReset = false
		}

		$scope.languages = ConfigHelper.getSectionValue(Enums.SimaxConfigSection.Languages)
		$scope.authenticationMode = ConfigHelper.getValue<Enums.AuthenticationMode>(Enums.SimaxConfigSection.Authentication, ConfigHelper.Key.Mode, {
			defaultValue: Enums.AuthenticationMode.Standard,
		})

		const sessionGuid: string = $location.search().sessionGuid

		if ($state.current.name == 'reset') {
			$scope.canReset = true

			$scope.$root.$broadcast('showLoadingIndicator')
			$scope.showLoader = true
			userSession
				.getDataProvider()
				.Operator.getPasswordPolicyRulles(sessionGuid)
				.then((rules: PasswordPolicyRules) => {
					if (rules != null) {
						if (this.newPasswordValidator != null) {
							this.newPasswordValidator.option({
								validationRules: getValidationRulesForNewPassword(rules),
							})
						}
					}
				})
				.always(() => {
					$scope.$root.$broadcast('hideLoadingIndicator')
				})

			if (!sessionGuid) $state.go('login')
		}

		if ($state.current.name == 'login') {
			CommonHelper.closeInfoPopup()
		}

		$scope.keyPressed = (keyEvent) => {
			if (keyEvent.keyCode === 13) {
				if ($scope.password != undefined && $scope.password.length > 0 && $scope.password2 != undefined && $scope.password2.length > 0) {
					$scope.passwordReset()
				} else if ($scope.loginModel.user != null && $scope.loginModel.user.length > 0 && $scope.loginModel.password == undefined && $scope.isReset == true) {
					$scope.sendEmail()
				}
			}
		}

		$scope.date = new Date()
		$scope.logIn = () => {
			$scope.showInfo = null
			if ($scope.loginForm.$invalid) {
				$scope.showError = i18n('Login', 'LoginErrorText')
			} else {
				var storagedDistributors = CommonHelper.getValueFromLocalStorage(CommonHelper.allowedDistributors)

				$scope.loginModel.locale = this.userSession.getDataProvider().System.getCurrentLanguage()
				$scope.loginModel.timeZone = moment.tz.guess()
				$scope.loginModel.distributors = storagedDistributors && angular.isObject(storagedDistributors) ? storagedDistributors[$scope.loginModel.user] : null

				var currentMd5 = Md5.init($scope.loginModel)
				if (this.previousLoginModelMd5 !== currentMd5 || this.loginFailed) {
					this.previousLoginModelMd5 = currentMd5

					const loginDefer = $q.defer<UserModel>()

					if (ConfigHelper.getValue(Enums.SimaxConfigSection.Api, ConfigHelper.Key.UseREST)) {
						$scope.$root.$broadcast('showLoadingIndicator')
						this.userSession
							.getDataProvider()
							.Session.login($scope.loginModel.user, $scope.loginModel.password, $scope.loginModel.locale, $scope.loginModel.timeZone, $state)
							.then((loggedOperator: OpOperator) => {
								var user = new UserModel()
								user.username = loggedOperator.login
								user.token = 'TODO: remove token'
								user.permissions = Permissions.getOperatorPermissions(loggedOperator)
								user.id = loggedOperator.idOperator
								user.idDistributor = loggedOperator.idDistributor
								user.name = loggedOperator.toString()
								user.avatar = loggedOperator.actor ? loggedOperator.actor.avatar : null

								$scope.loginModel.fakeUser = user

								var fakeSession: SessionModel = new SessionModel()
								var session: SESSION = userSession.getDataProvider().Session.getSession()
								fakeSession.guid = session.guid
								fakeSession.imrWcfAddress = session.imrWcfAddress
								var time = moment(session.time)
								fakeSession.time = time.add(time.utcOffset(), 'minutes').toDate()
								fakeSession.status = 0
								fakeSession.error = null

								$scope.loginModel.fakeSession = fakeSession

								api.login
									.login($scope.loginModel)
									.then((result) => {
										loginDefer.resolve(result)
									})
									.catch((error) => {
										loginDefer.reject(error)
									})
							})
							.fail((msg) => {
								loginDefer.reject(msg)
							})
							.always(() => {
								$scope.$root.$broadcast('hideLoadingIndicator')
							})
					} else {
						throw new Error('Configure application to use rest api')
					}

					return loginDefer.promise
						.then((result) => {
							delete result.avatar //avatar zajmuje dużo miejsca, a jest już zapisany w loggedOperator
							CommonHelper.setValueToLocalStorage('USER', result, 0)
							$scope.$root.$broadcast(EventsNames.ON_LOGGED)
							this.loginFailed = false
						})
						.catch((error) => {
							$scope.showError = i18n('Login', 'LoginErrorText')

							if (error.error.errorCode != null) {
								ToastHelper.showError
								ToastHelper.showErrorWithContent(error.error.msg, error.error.errorCode.toString(), {
									displayTime: 4000,
								})
							} else {
								ToastHelper.showError(error.error.msg, {
									displayTime: 4000,
								})
							}

							this.loginFailed = true
							logger.log(error)
						})
				}
			}
		}

		$scope.setLocale = (locale) => {
			this.userSession.getDataProvider().System.setCurrentLanguage(locale)
			CommonHelper.clearLocalStorage('SETTINGS')
			CommonHelper.clearLocalStorage('BusinessDictionary')
			CommonHelper.clearLoadedSettings()
			setTimeout(() => {
				window.location.reload()
			}, 100)
		}

		$scope.sendEmail = () => {
			var model = new PasswordResetEmailModel()
			model.user = $scope.loginModel.user
			model.locale = this.userSession.getDataProvider().System.getCurrentLanguage()

			api.password
				.reset(model)
				.then((result) => {
					if (result == 'OK') {
						$scope.showError = null
						$scope.showInfo = i18n('Login', 'PasswordResetEmail')
						$scope.isReset = false
					} else {
						$scope.showError = result
					}
				})
				.catch(() => {
					$scope.showError = i18n('Login', 'PasswordResetEmailError')
				})
		}

		$scope.passwordReset = () => {
			if (this.newPasswordValidator != null && this.newPasswordConfirmValidator != null) {
				let validateErrorMessage: string = ''

				const newPassValidationResult: dxValidatorResult = this.newPasswordValidator.validate()
				const newPassConfirmValidationResult: dxValidatorResult = this.newPasswordConfirmValidator.validate()

				if (newPassValidationResult.isValid == false) {
					validateErrorMessage = newPassValidationResult.brokenRule.message
				} else if (newPassConfirmValidationResult.isValid == false) {
					validateErrorMessage = newPassConfirmValidationResult.brokenRule.message
				}

				const isValid: boolean = newPassValidationResult.isValid && newPassConfirmValidationResult.isValid

				if ($scope.password == $scope.password2 && isValid) {
					var model = new PasswordResetModel()

					model.guid = sessionGuid
					model.password = $scope.password
					model.locale = this.userSession.getDataProvider().System.getCurrentLanguage()

					api.password.change(model).then((result) => {
						if (result.status == 'OK') {
							$scope.isReset = false
							$scope.canReset = false
							$scope.showError = null
							$scope.showInfo = result.message
						} else {
							$scope.showError = result.message
						}
					})
				} else {
					$scope.showError = validateErrorMessage
				}
			}
		}

		$scope.newPasswordInputOptions = {
			mode: 'password',
			placeholder: i18n('Login', 'NewPassword'),
			bindingOptions: {
				value: 'password',
			},
			buttons: [
				<dxTextEditorButton>{
					name: 'password',
					location: 'before',
					options: <dxButtonOptions>{
						activeStateEnabled: true,
						hoverStateEnabled: false,
						type: 'normal',
						stylingMode: 'text',
						disabled: false,
						icon: `images/${$scope.loginScreenTheme}/pass.png`,
						inputAttr: {
							autocomplete: 'new-password',
						},
					},
				},
			],
		}

		$scope.confirmNewPasswordInputOptions = {
			mode: 'password',
			placeholder: i18n('Login', 'NewPassword'),
			bindingOptions: {
				value: 'password2',
			},
			buttons: [
				<dxTextEditorButton>{
					name: 'password',
					location: 'before',
					options: <dxButtonOptions>{
						activeStateEnabled: true,
						hoverStateEnabled: false,
						type: 'normal',
						stylingMode: 'text',
						disabled: false,
						icon: `images/${$scope.loginScreenTheme}/pass.png`,
						inputAttr: {
							autocomplete: 'new-password',
						},
					},
				},
			],
		}

		$scope.passwordValidationRules = {
			onInitialized: (e: any) => {
				this.newPasswordValidator = e.component
			},
		}

		$scope.confirmPasswordValidationRules = {
			validationRules: [CommonHelper.requiredField(), CommonHelper.compareField(() => $scope.password)],
			onInitialized: (e: any) => {
				this.newPasswordConfirmValidator = e.component
			},
		}

		//dropdown menu | Math.round is FF fix
		var dropdownWidth = Math.round(angular.element('.dropdown-menu').width() + 32)
		angular.element('.dropdown-button').css('width', dropdownWidth + 'px')

		$scope.owner = 'Aiut Sp. z o.o.'
		const owner: string = ConfigHelper.getDefaultValue(Enums.SimaxConfigSection.Owner)
		if (owner != null) {
			$scope.owner = owner
		}

		$scope.windows10CompatibileHidden = ConfigHelper.getDefaultValue(Enums.SimaxConfigSection.Windows10CompatibileHidden)

		const getValidationRulesForNewPassword = (rules: PasswordPolicyRules): RequiredRule[] => {
			const validationRules: RequiredRule[] = [CommonHelper.requiredField()]

			if (rules.minLength > 0) {
				validationRules.push(CommonHelper.minLenghtField(rules.minLength))
			}

			if (rules.minDigitsCount > 0) {
				validationRules.push(CommonHelper.minNumbersField(rules.minDigitsCount))
			}

			if (rules.minLowerLettersCount > 0) {
				validationRules.push(CommonHelper.minLowerCaseField(rules.minLowerLettersCount))
			}

			if (rules.minSpecialSymbolsCount > 0) {
				validationRules.push(CommonHelper.minSpecialSymbolsField(rules.minSpecialSymbolsCount))
			}

			if (rules.minUpperLettersCount > 0) {
				validationRules.push(CommonHelper.minUpperCaseField(rules.minUpperLettersCount))
			}

			return validationRules
		}
	}
}
